import React, { useState, useEffect } from 'react';
import Styled, { css, keyframes } from 'styled-components';
import {fontQuicksand} from './mixin';
import i18n from '../../utils/i18n';
import connect from '../../stores/parent-dashboard';
import InfoBadge from './info-badge';
import { computePricingInfo, amountInLocalCurrency, melaDurationMap} from '../../../js_bytesize/templates/purchase/pricing-helper';
import { device } from '../../utils/responsive_utilities';
import Image from '../loggedout/common/Image';
import PurpleTick from '~images/mela-purchase/purple-tick.svg';
import PurchaseTimerCountDown from '../purchase-timer-countdown/PurchaseTimerCountdown';
import { fontGraphie } from '../../../fonts/mixin';
import { DiscountBadgePink, DiscountBadgeRed } from '../freemium/image-cdn-urls';
import {shimmerEffect} from '../../common-animations/animation-functions/animations'
import { PARENTPTL_NEW_SIGNUPS_DISCOUNT_CODE } from '../../constant-data/constants';
import TeacherDiscount from './teacher-discount'
import styled from 'styled-components';

const DEFAULT_PLAN_DURATION = "Yearly";
function ProductPlan({
  products,
  activeFilterTab,
  showMorePlans,
  setShowMorePlans,
  initialDuration,
  activePlanHandler,
  selectedBox,
  selectedPlan,
  settings,
  subjectsLength,
  sortedDurationList,
  savePercentage,
  percentOffAmount,
  showDiscountChanges,
  timeLeft,
  stripePaymentElement,
  updateProductPurchaseContext
}) {
  let showSocialNudge = (subjectsLength > 1 && activeFilterTab.id==='mela') || subjectsLength==1;
  const showMorePlansClicked = () => {
    if(stripePaymentElement) {
      updateProductPurchaseContext({
        stripePaymentElement: null
      });
    }
    setShowMorePlans(!showMorePlans);
    trackAnalyticsEvent('Interacted Plan Purchase Combined Page', {'clicked': "View More Plans", 'Clicked On': "View More Plans"});
  }
  const shorterDurationProduct = products.get(sortedDurationList[sortedDurationList.length - 1])[0];
  let quarterlyPriceInfo = computePricingInfo(shorterDurationProduct, settings);
  let quarterlyMonthlyPrice = quarterlyPriceInfo.actualMonthlyPrice;
  const isMelaEligible = settings.student_courses && settings.student_courses.length > 1;
  const totalProducts = products?.size;
  const isPtlUser = localStorage.getItem('isPtlUser') == 'true' || false;
  function sendPercentOff(discountPerc,val){
    let modifiedDiscountedPerc=discountPerc
    
    if(showDiscountChanges && settings?.coupon && settings?.coupon?.stripe_id==PARENTPTL_NEW_SIGNUPS_DISCOUNT_CODE){
      modifiedDiscountedPerc=null
    }
    return modifiedDiscountedPerc
  }
  const [showDiscountBadgeAnimation, setShowDiscountBadgeAnimation]=useState(!localStorage.getItem('seenDiscountBadgeAnimation') ? true:false)
  const [showFamilyPlan, setShowFamilyPlan]=useState(true)
  useEffect(()=>{
    let timeout=null
    if(showDiscountChanges && !localStorage.getItem('seenDiscountBadgeAnimation')){
      timeout = setTimeout(()=>{
        // show animation 
        localStorage.setItem('seenDiscountBadgeAnimation', true)
        setShowDiscountBadgeAnimation(false)
      },[3000])
    }
    showDiscountChanges && setShowFamilyPlan(false)
    return ()=>{
      if(timeout!==null) clearTimeout(timeout)
    }
  },[showDiscountChanges])

  useEffect(()=>{
   if(showMorePlans) setShowFamilyPlan(true)
  },[showMorePlans])
  return (
    <>
      <PlanBoxWrapper>
        {[...products.keys()].map((val) => (
          <>
            {(val === initialDuration || showMorePlans) && (
              <PlanBox
                duration={val}
                activeBox={initialDuration === val}
                showMorePlans={showMorePlans}
                showDiscountChanges={showDiscountChanges}
              >
                {showDiscountChanges && val == DEFAULT_PLAN_DURATION ? (
                  <DiscountBadge>
                    <BadgeContainer>
                      <ImageContainer>
                        <Image
                          src={
                            showDiscountBadgeAnimation
                              ? DiscountBadgePink
                              : DiscountBadgeRed
                          }
                        />
                      </ImageContainer>
                    </BadgeContainer>
                    <BadgeDescription
                      showDiscountBadgeAnimation={showDiscountBadgeAnimation}
                      className={showDiscountBadgeAnimation ? 'shimmerBG' : ''}
                    >
                      <BadgeDescriptionText>
                        Limited Time Offer applied &nbsp;
                      </BadgeDescriptionText>
                      <Dot
                        showDiscountBadgeAnimation={showDiscountBadgeAnimation}
                      ></Dot>
                      Expires in&nbsp;{' '}
                      <PurchaseTimerCountDown timeLeft={timeLeft} />
                    </BadgeDescription>
                  </DiscountBadge>
                ) : null}
                {initialDuration === val && (
                  <Image className="purple-tick" src={PurpleTick} />
                )}
                {!isPtlUser ? (
                  <InfoBadge
                    showSaving={
                      showDiscountChanges &&
                      settings?.coupon &&
                      settings?.coupon?.stripe_id ==
                        PARENTPTL_NEW_SIGNUPS_DISCOUNT_CODE
                        ? false
                        : showMorePlans && val === DEFAULT_PLAN_DURATION
                    }
                    showSubjectNameOnSelectedTile={
                      !showMorePlans &&
                      !(
                        DEFAULT_PLAN_DURATION == val &&
                        (isMelaEligible
                          ? activeFilterTab.id === 'mela'
                          : activeFilterTab.id == 'math')
                      )
                    }
                    showSuperSaverTag={
                      showDiscountChanges &&
                      settings?.coupon &&
                      settings?.coupon?.stripe_id ==
                        PARENTPTL_NEW_SIGNUPS_DISCOUNT_CODE
                        ? false
                        : totalProducts > 1 &&
                          !showMorePlans &&
                          DEFAULT_PLAN_DURATION === val &&
                          (isMelaEligible
                            ? activeFilterTab.id === 'mela'
                            : activeFilterTab.id == 'math')
                    }
                    subject={activeFilterTab}
                    settings={settings}
                    percentOff={sendPercentOff(percentOffAmount, val)}
                    savePercentage={savePercentage}
                    showMorePlans={showMorePlans}
                    // showSocialNudge={showSocialNudge}
                  />
                ) : null}
                {showMorePlans &&
                val === DEFAULT_PLAN_DURATION &&
                showSocialNudge && !isPtlUser &&
                !showDiscountChanges ? (
                  <PreferredBadge>Preferred by 80% parents</PreferredBadge>
                ) : val === DEFAULT_PLAN_DURATION &&  isPtlUser &&<TeacherRefferalContainer showMorePlans={showMorePlans}>
                <TeacherDiscount></TeacherDiscount>
              </TeacherRefferalContainer> }

                <TitleWrapper>
                  {val === DEFAULT_PLAN_DURATION ? (
                    <PlanTitle>{val}</PlanTitle>
                  ) : null}
                  {!showDiscountChanges &&
                    !showMorePlans &&
                    DEFAULT_PLAN_DURATION === val &&
                    (isMelaEligible
                      ? activeFilterTab.id === 'mela'
                      : activeFilterTab.id == 'math') && (
                      <SubjectStripe> {activeFilterTab.title} </SubjectStripe>
                    )}
                </TitleWrapper>

                <Plan
                  product={products.get(val)}
                  tileName={val}
                  selectedPlan={selectedPlan}
                  activePlanHandler={activePlanHandler}
                  settings={settings}
                  initialDuration={initialDuration}
                  quarterlyMonthlyPrice={quarterlyMonthlyPrice}
                  showDiscountChanges={showDiscountChanges}
                  showFamilyPlan={showFamilyPlan}
                />
              </PlanBox>
            )}
          </>
        ))}
      </PlanBoxWrapper>
      {!showMorePlans && sortedDurationList.length > 1 && (
        <ShowMore onClick={showMorePlansClicked}>More Plans</ShowMore>
      )}
    </>
  );
}

function Plan({product, selectedPlan, tileName, activePlanHandler, settings, initialDuration, quarterlyMonthlyPrice, showDiscountChanges,showFamilyPlan}) {
  let isYearly = tileName===DEFAULT_PLAN_DURATION || false;
  let {id:planId} = selectedPlan;
  const getCreditCount = (product) => {
    if(product.credit_count!=undefined){
      return product.credit_count
    }else{
      return product.credit_products[0].credits_count
    }
  }


  return(
    <>
      {product.map((item)=>{
        const modifiedSettings= {...settings}
        const modifiedItem={...item}


        
        let priceinfo = computePricingInfo(modifiedItem, modifiedSettings);
        let {actualMonthlyPrice, actualPrice, discountedPrice, discountedMonthlyPrice, percentOff} = priceinfo;
        let strikedOffPrice = !!percentOff ? discountedMonthlyPrice : actualMonthlyPrice;
        let strikingPrice = !!percentOff ? actualMonthlyPrice : quarterlyMonthlyPrice;
        let showDiscount = strikedOffPrice != strikingPrice
        
        function savePrice(){
          if(modifiedItem.credit_count==3){
            return Math.round((quarterlyMonthlyPrice/100)*12*3).toFixed(2) - (actualPrice/100)
          }
          if(modifiedItem.credit_count==1){
            return Math.floor((Math.round((quarterlyMonthlyPrice/100)*12).toFixed(2) - (discountedPrice/100)).toFixed(2))
          }
        }
        return(
          <>
        {isYearly ? <YearlyPlans hideInDiscountChanges={showDiscountChanges && !settings.eligible_product_codes.includes(item.code) && !showFamilyPlan}>
            <input type="radio" id={modifiedItem.id} onChange={()=>activePlanHandler(tileName, modifiedItem)} class="custom-control-input" name="yearlyPlan" checked={planId===modifiedItem.id} />
            <StyledLabel class="custom-control-label" htmlFor={modifiedItem.id} isYearly={isYearly}>
              <div>
                {isYearly && <ChildCount>{getCreditCount(modifiedItem) == 1 ? `1 Child` : `Up to ${getCreditCount(modifiedItem)} children`}</ChildCount>}
                {!percentOff && <PlanCost showDiscountChanges={ showDiscountChanges}>Billed {melaDurationMap[modifiedItem.access_duration].toLowerCase()} at {showDiscountChanges && !settings.eligible_product_codes.includes(modifiedItem.code) && <StrikeThroughPrice>{Math.round((quarterlyMonthlyPrice/100)*12*3).toFixed(2)}&nbsp;</StrikeThroughPrice>}&nbsp;<DiscountedPrice showDiscountChanges={ showDiscountChanges}>
                  {amountInLocalCurrency(actualPrice, modifiedItem)}
                  </DiscountedPrice>
                  </PlanCost>}

                
                {!!percentOff && <PlanCost showDiscountChanges={ showDiscountChanges}>Billed {melaDurationMap[modifiedItem.access_duration].toLowerCase()} at {showDiscountChanges && <StrikeThroughPrice>{Math.round((quarterlyMonthlyPrice/100)*12).toFixed(2)}</StrikeThroughPrice>} <DiscountedPrice showDiscountChanges={ showDiscountChanges}>
                  {amountInLocalCurrency(discountedPrice, modifiedItem)}
                  </DiscountedPrice>
                  </PlanCost>}
                {showDiscountChanges ? <SavingCostDescription>
                  You will be saving <CostSaved>${savePrice()}</CostSaved>
                </SavingCostDescription>:null}
                {}
              </div>
              <div>
                {showDiscount && !showDiscountChanges && <Amount showDiscount={showDiscount}>{amountInLocalCurrency(strikingPrice, modifiedItem, !percentOff && true)}</Amount>}
                {<Amount discount={showDiscount}>{amountInLocalCurrency(strikedOffPrice, modifiedItem, true)}</Amount>}
                {modifiedItem.properties.title0==='family' ? <PerChild>per child</PerChild> : null}
              </div>
            </StyledLabel>

        </YearlyPlans> : <ShortTermPlans onClick={()=>activePlanHandler(tileName, modifiedItem)}>
          <div>
            <PlanTitle>{tileName}</PlanTitle>
            {!percentOff &&<PlanCost>Billed {melaDurationMap[modifiedItem.access_duration].toLowerCase()} at {amountInLocalCurrency(actualPrice, modifiedItem)}</PlanCost>}
            {!!percentOff &&<PlanCost>Billed {melaDurationMap[modifiedItem.access_duration].toLowerCase()} at {amountInLocalCurrency(discountedPrice, modifiedItem)}</PlanCost>}
          </div>
          <div>
            <Amount showDiscount={!!percentOff}>{amountInLocalCurrency(actualMonthlyPrice, modifiedItem, !percentOff && true)}</Amount>
            {!!percentOff && <Amount discount={true}>{amountInLocalCurrency(discountedMonthlyPrice, modifiedItem, true)}</Amount>}
            {/* {item.properties.title0==='family' ? <PerChild>per child</PerChild> : null} */}
          </div>
        </ShortTermPlans>}</>
      )})}
    </>
  )
}
export const PlanBoxWrapper = Styled.ul`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  position: relative;
  /* margin-top: -80px; */
`;
export const PlanBox = Styled.li`
  box-sizing: border-box;
  background-color: ${props=>props.activeBox ? '#2284E2' : 'transparent'};
  border-radius: 1.2rem;
  border: 1px solid ${props=>props.activeBox ? '#4E9DE8' : '#4F52C3'};
  margin: ${props=>props.showDiscountChanges ? '2rem' :props.showMorePlans ? '1.6rem' : 0 } auto 0;
  ${props=>props.duration === 'Yearly' && `padding: 1.5rem 2.6rem;`}
  width: 47rem;
  position:relative;
  /* transition: all 0.5s ease-in-out; */
  order: ${props=> props.duration === 'Yearly' ? 0 : 1};
  .purple-tick {
    position: absolute;
    right: 0.7rem;
    top: 0.7rem;
  }
  @media ${device.PhoneLargeScreen} {
    width: 37rem;
    ${props=>props.duration === 'Yearly' && `padding: 1.5rem;`}
    .purple-tick {
      width: 1.6rem;
    }
  }
  @media ${device.Phone} {
    width: 34rem;
    ${props=>props.duration === 'Yearly' && `padding: 1.3rem;`}
    .purple-tick {
      width: 1.6rem;
    }
  }
`

export const YearlyPlans = Styled.div`
  text-align: left;
  margin-top: 1.2rem;
  display: ${props=> props.hideInDiscountChanges ? "none" : "flex"};
  justify-content: space-between;
  input[type="radio"] {
    opacity: 0;
    width:0;
    height:0;

  }
  input[type="radio"]:checked + label::after {
    border-width: 4px;
  }
`

export const Amount = Styled.span`
  text-align: right;
  align-self: center;
  ${fontQuicksand(1.8, 2.2, 7)}
  ${props=>props.showDiscount &&
    `text-decoration: line-through;
      ${fontQuicksand(1.2, 1.6, 7)};
      margin-right: 1rem;
    `
  }
  ${props=>props.discount &&
    `color: #A5F9E8;
    `
  }
  @media ${device.PhoneLargeScreen} {
    ${fontQuicksand(1.4, 2, 7)}
  }
  @media ${device.Phone} {
    ${fontQuicksand(1.4, 2, 7)}
  }
`;

export const PreferredBadge = Styled.span`
  font: normal bold 1.2rem/1.6rem Quicksand;
  position: absolute;
  padding: 0.3rem 1rem;
  background-color: #A5F9E8;
  top: -2.3rem;
  left: 2.2rem;
  border-radius: 1rem 1rem 0 0;
  color: #141953;
`;

export const PlanTitle = Styled.p`
  text-align: left;
  ${fontQuicksand(2, 2.6, 7)}
  @media ${device.PhoneLargeScreen} {
    ${fontQuicksand(1.6, 2, 7)}
  }
  @media ${device.Phone} {
    ${fontQuicksand(1.6, 2, 7)}
  }
`;

export const ChildCount = Styled.span`
  ${fontQuicksand(1.4, 1.8, 7)}
  @media ${device.Phone} {
    ${fontQuicksand(1.3, 1.6, 7)}
  }

`;

export const PlanCost = Styled.span`
  ${fontQuicksand(1.2, 1.4, 5)}
  color: ${props=> props.showDiscountChanges ? '#EDEFFF':'#A5F9E8'};
  @media ${device.Phone} {
    ${fontQuicksand(1.2, 1.5, 7)}
  }
`;

export const StyledLabel = Styled.label`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1;
  ${props=>props.isYearly && 'padding-left: 3rem'};
  position: relative;
  &:after {
    content: '';
    opacity: ${props=>!props.isYearly ? 0 : 1};
    width: 1.6rem;
    height: 1.6rem;
    left: 0;
    position: absolute;
    border: 1px solid #fff;
    border-radius: 50%;
    box-sizing: border-box;
    background-color: transparent;
  }
  div:first-of-type {
    flex:1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

export const PerChild = Styled.span`
  display: block;
  text-align: right;
  ${fontQuicksand(1, 1.4, 5)};
`;

export const ShowMore = Styled.p`
  width:47rem;
  text-align: left;
  margin: 1rem auto;
  text-decoration: underline;
  cursor: pointer;
  ${fontQuicksand(1.5, 2.1, 7)}
  @media ${device.PhoneLargeScreen} {
    width: 37rem;
    ${fontQuicksand(1.3, 1.7, 7)}
  }
  @media ${device.Phone} {
    width: 34rem;
    padding: 0 1.5rem;
    ${fontQuicksand(1.3, 1.7, 7)}
  }
`;
export const ShortTermPlans = Styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2.4rem 2.6rem;
  cursor: pointer;
  @media ${device.PhoneLargeScreen} {
    padding: 1.5rem;
  }
  @media ${device.Phone} {
    padding: 1.3rem;
  }
`;

const SubjectStripe = Styled.div`
  padding: 0.1rem 0.6rem;
  height: 1.8rem;
  color: #141953;
  background: #FD9B7D;
  border-radius: 0.2rem;
  margin: auto 1rem;
  ${fontQuicksand(1.2,1.5,7)};

  @media ${device.Phone}{
    width: 9.1rem;
    height: 1.6rem;
    ${fontQuicksand(1.1,1.4,7)};

  }
`;
export const DiscountBadge = Styled.div`
    align-items: center;
    display: flex;
    position: absolute;
    display: flex;
    top: -4.36rem;
    left: 1rem;

`;
export const BadgeContainer = Styled.div`
    position: relative;
    left: 0.8rem;
`;
export const BadgeDescription = Styled.div`
    display: flex;
    align-items: center;
    border-radius: 0 0.6rem 0 0;
    height: max-content;
    background-color: ${props => props.showDiscountBadgeAnimation ? '#F1DAFA' : '#FFDDDB'};
    padding: 0 0.8rem;
    color: ${props => props.showDiscountBadgeAnimation ? '#B746E6' : '#C20F03'} ;
    ${fontGraphie(2.4,1.6,6)};

    &.shimmerBG{
      animation :  ${shimmerEffect()} 7s linear infinite; 
       background: linear-gradient(270deg, white 12%, #F1DAFA 70%); 
       background-size: 1200px 100%; 
    }
`;
export const BadgeDescriptionText = Styled.div`

`;
export const Dot = Styled.div`
background-color: ${props => props.showDiscountBadgeAnimation ? '#B746E6' : '#C20F03'};
    height: 0.5rem;
    width: 0.5rem;
    border-radius: 100%;
    margin-top: 0.2rem;
    margin-right: 0.5rem;
`;
export const ImageContainer = Styled.div``;

export const SavingCostDescription = Styled.span`
background-color:#EDEFFF;
${fontGraphie(1.4,1.2,4)};
color:#17147A;
max-width: max-content;
    padding: 0 0.4rem;
    border-radius: 0.2rem;
    margin-top: 0.4rem;
`;
export const CostSaved=Styled.span`
font-weight: 700;
`;

const TitleWrapper = Styled.div`
  display: flex;
`;

const StrikeThroughPrice = Styled.span`
text-decoration: line-through;
`;

const DiscountedPrice= Styled.span`
color: ${props=> props.showDiscountChanges ? '#EDEFFF':'#A5F9E8'};
font-weight: ${props=> props.showDiscountChanges ? 700:400};
`;

const TeacherRefferalContainer = styled.div`
  position: absolute;
  top: -4.3rem;
  left: 50%;
  transform: translateX(-50%);
`

export default connect(null, null, ProductPlan)
